module.exports = __webpack_public_path__ + "static/img/sticker-buy-now.932f223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/banner/sticker/sticker-buy-now.png
// module id = MKP6
// module chunks = 134